<template>
  <v-dialog :value="enabled" width="640" scrollable>
    <v-card class="pt-6">
      <v-card-text v-html="content" />
      <v-card-actions class="px-6 pb-6">
        <v-spacer />
        <v-btn class="c360-button" rounded @click="onAccept">
          <span class="button-text ml-2">Continue</span>
          <c360-icon icon="Arrow_Right_SM" class="mr-2 ml-2" />
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import { C360Icon } from '../../Icon';
  import { WHAT_IS_NEW_UPDATED_AT_KEY } from '../lib';

  export default {
    name: 'C360WhatIsNewModal',

    props: {
      enabled: {
        type: Boolean,
        default: false,
      },
      content: {
        type: String,
        default: '',
      },
      updatedAt: {
        type: String,
        default: '',
      },
    },

    methods: {
      onAccept() {
        localStorage.setItem(WHAT_IS_NEW_UPDATED_AT_KEY, JSON.stringify(this.updatedAt));
        this.$emit('close');
      },
    },

    components: {
      C360Icon,
    },
  };
</script>

<style scoped>
  .button-text {
    letter-spacing: -0.02rem;
    text-transform: none;
  }
</style>
